/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { FormEventHandler, ReactNode } from "react";
import { Box, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import formHeaderWrapperStyle from "./formHeaderWrapperStyles";
import FormSubmitProps from "@/src/types/FormSubmitProps";

type FormHeaderWrapperProps = {
  children: ReactNode;
  submitProps: FormSubmitProps;
  handleSubmit: FormEventHandler;
};

export function FormHeaderWrapper({ children, submitProps, handleSubmit }: FormHeaderWrapperProps) {
  return (
    <Paper elevation={4} sx={formHeaderWrapperStyle.paper}>
      <FormFader>
        <Box component={"form"} sx={formHeaderWrapperStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[formHeaderWrapperStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Ihr Vertrag
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>Details zu Ihrem Vertrag</strong>
              </FormLegend>
            </Grid>
            {children}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
